import React from 'react'

import { useVariant } from 'src/AmplitudeExperimentProvider'

import { RenderModules } from 'src/utils/renderModules'

export interface ExperimentProps {
  data: {
    experimentKey: string
    variantModules: unknown[]
    controlModules: unknown[]
  }
}

export const Experiment = ({ data }: ExperimentProps) => {
  const variant = useVariant(data.experimentKey)

  const modules: any = variant.enabled ? data.variantModules : data.controlModules
  const hasModules = modules && modules.length > 0

  return hasModules ? <>{RenderModules(modules)}</> : <></>
}

export default Experiment
